import React from 'react';
import glamorous from 'glamorous';

import FiltersPopover from '../features/FiltersPopover';
import { TaraPopover } from '../features/Tara';
import Button from '../ui/Button';
import Popover from '../ui/Popover';

import StickersheetRow from './StickersheetRow';

const Row = glamorous.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
});

const DefaultPopover = () => (
  <Popover
    renderOpen={(handleOpen) => (
      <Button
        onClick={handleOpen}
        label="Default"
        marginRight={16}
      />
    )}
  >
    Default Popover Content
  </Popover>
);

export default () => (
  <StickersheetRow title="Popovers">
    <Row>
      <DefaultPopover />
      <FiltersPopover hasButton />
      <TaraPopover hasButton />
    </Row>
  </StickersheetRow>
);



// WEBPACK FOOTER //
// ./src/components/demo/Popovers.js